import { Slot } from 'expo-router'

import { CommonLayout } from '@/src/elements/templates/CommonLayout'

export default function () {
  return (
    <CommonLayout>
      <Slot />
    </CommonLayout>
  )
}
